<template>
  <div>
    <!-- 실시현황 칸 클릭 → 주요의견 및 조치사항의 해당 회의·기간·사업장으로 이동. 조치 결과 저장 → 실시현황 다시 집계 -->
    <Status ref="status" class="mb-7" @select-meeting="onSelectMeeting" />
    <FeedbackActions ref="feedback" @saved="onSavedResults" />
  </div>
</template>

<script>
import Status from "./Status.vue";
import FeedbackActions from "./FeedbackActions.vue";
export default {
  components: {
    Status,
    FeedbackActions,
  },
  methods: {
    onSelectMeeting(meeting) {
      if (this.$refs.feedback) this.$refs.feedback.showMeeting(meeting);
    },
    onSavedResults() {
      if (this.$refs.status) this.$refs.status.reloadPost();
    },
  },
};
</script>

<style lang="scss" scoped></style>
